<template>
  <div class="_popup-container" @click.stop="closePopup" v-if="open">
    <div class="_popup-card" :style="`padding-top: ${showIcon ? 70 : 20}px`">
      <img
        v-if="showIcon"
        class="top-icon"
        src="../assets/personal/popup_icon@2x.png"
        alt=""
      />
      <div class="_popup-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MlPopup",
  props: {
    showIcon: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    open(newVal) {
      if (newVal === true) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    }
  },
  methods: {
    closePopup(event) {
      if (event.target.className === "_popup-container") {
        this.$emit("update:open", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
._popup-container {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  ._popup-card {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding-bottom: 20px;
    width: 280px;
    background: rgba(255, 255, 255, 1);
    border-radius: 12px;
    .top-icon {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 155px;
      height: 101px;
    }
    ._popup-content {
      padding: 0 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      h1 {
        font-size: 16px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
      }
      p {
        margin: 15px 0 30px 0;
      }
    }
  }
}
</style>
